import CONST from '../../../../../includes/primitives/_constant_trion'

export default {
  data: () => ({

    HOST: CONST.HOST_NAME_RESOURCE + '/resources',
    cutoff:       null,
    
    canvasGroup:  null,
    canvasChart:  null,

    timeline:     {},
    primary:      {axis: null, max: null},
    secoundary:   {axis: null, max: null},

    title:        null,
    chart:        null,
    legends:      null,

  }),


  computed: {

    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
    
  },

}